import React, { useState, useEffect } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";

import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProductDrop = ({ show, onClose, selectedId, refresh }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const [productOption, setProductOption] = useState([]);
    useEffect(() => {
        const fetch = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/subscription/${selectedId}`);
                const formattedsource = response.data.data.map(item => ({
                    // value: item.sno,
                    // label: item.product_name + ' (' + item.timeline_name + ') ' + item.area_name,
                    value: item.sno,
                    title: item.product_name,
                    subtitle: item.timeline_name + ' (' + item.timeline_days + ' Days) ' + ' - ' + item.area_name,
                    description: formatDate(item.start_date) + ' to ' + formatDate(item.end_date),
                    label: item.product_name, // keep this for default filter/search
                }));
                setProductOption(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetch();
    }, []);

    const [dropOption, setDropOption] = useState([]);
    const [reason, setReason] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/dropreason`);
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.reason_name,
                }));
                setDropOption(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
    };

    const [isRefundChecked, setIsRefundChecked] = useState(false);
    const handleRefundCheckboxChange = (e) => {
        setIsRefundChecked(e.target.checked);
    };
    
    const [selectedProducts, setSelectedProducts] = useState([]);

    const handleChange = (selectedOptions) => {
        if (selectedOptions) {
            setSelectedProducts(selectedOptions.map(option => option.value));
        } else {
            setSelectedProducts([]);
        }
    };

    const Group = (props) => (
        <div style={customStyles}>
            <components.Group {...props} />
        </div>
    );
    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',  // Increase the font size for group labels
            fontWeight: 'bold',  // Optional: make the label bold
            color: '#333',  // Optional: change the text color
        }),
    };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if (selectedProducts.length === 0) {
            newErrors.prod = "This Field is Required.";
        }

        if (!reason) {
            newErrors.reson = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        updatedrop();

    };

    const updatedrop = async () => {
        try {

            let refund = 0;
            if (isRefundChecked) {
                refund = 1;
            }

            const postData = { drop_reason: reason, refund: refund, updated_by: user_id, };

            const requests = selectedProducts.map(value =>
                axios.put(`${baseURL}/leadsubscription/drop/${value}`, postData)
            );

            await Promise.all(requests);

            onClose();
            refresh();
            toast.success("Subscriptions Dropped Successfully!");
        } catch (error) {
            onClose();
            console.error(error);
            toast.error("Subscription Drop Failed");
        }
    };


    return (
        <Modal show={show} size="md"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Drop Products</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-3 mt-3">
                        <div className='col-lg-12 mb-3'>
                            <label className="text-black font-w500 fs-7">Product<span className="required">*</span></label>
                            <Select isMulti placeholder='Select Product'
                                options={productOption}
                                // components={{ Group }}
                                styles={customStyles}
                                onChange={handleChange}
                                components={{
                                    Option: (props) => {
                                        const { data, innerRef, innerProps, isFocused, isSelected } = props;
                                        return (
                                            <div
                                                ref={innerRef}
                                                {...innerProps}
                                                style={{
                                                    backgroundColor: isFocused ? '#eee' : isSelected ? '#ddd' : 'white',
                                                    padding: 10,
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                <div style={{ fontWeight: 'bold', fontSize: '1rem', color: '#333' }}>
                                                    {data.title}
                                                </div>
                                                <div style={{ fontSize: '0.8rem', color: '#666' }}>
                                                    {data.subtitle}
                                                </div>
                                                <div style={{ fontSize: '0.8rem', color: '#666' }}>
                                                    {data.description}
                                                </div>
                                            </div>
                                        );
                                    },
                                    Group,
                                }}
                            />
                            {errors.prod && <div className="text-danger fs-8 mt-1">{errors.prod}</div>}
                        </div>

                        <div className="col-lg-12 mb-3">
                            <div className="d-flex justify-content-between">
                                <label className="text-black font-w500 fs-7">
                                    {isChecked ? 'Custom Reason' : 'Drop Reason'}<span className="required">*</span>
                                </label>
                                <label className="text-black font-w500 fs-7">
                                    <input
                                        type="checkbox"
                                        onChange={handleCheckboxChange}
                                        className="form-check-input me-2 mt-0 mb-2"
                                        id="customCheckBox1"
                                    />
                                    Custom Reason
                                </label>
                            </div>

                            {!isChecked ? (
                                <Select
                                    placeholder="Select Drop Reason"
                                    options={dropOption}
                                    onChange={(option) => {
                                        setReason(option.label);
                                    }}
                                />
                            ) : (
                                <textarea
                                    className="form-control"
                                    placeholder="Enter Drop Reason"
                                    onChange={(option) => {
                                        setReason(option.target.value);
                                    }}
                                />
                            )}

                            {errors.reson && <div className="text-danger fs-8 mt-1">{errors.reson}</div>}
                        </div>

                        <div className='col-lg-12'>
                            <div className="d-flex justify-content-between">
                                <label className="text-black font-w500 fs-7">
                                    <input
                                        type="checkbox"
                                        onChange={handleRefundCheckboxChange}
                                        className="form-check-input me-2 mt-0 mb-2"
                                        id="customCheckBox2"
                                    />
                                    Refund
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                        <Link className="btn btn-sm btn-primary" onClick={handleSubmit}>Yes, Drop It  <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ProductDrop;
